import { faviconConfig } from '@/common/app.config.js'

export default function setFavicon() {
    let faviconEles = document.querySelectorAll('link[rel=icon]')

    faviconEles.forEach(ele => {
        ele.href = faviconConfig
    })
}